var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-howworks new-howworks" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "title" }, [
            _c(
              "h2",
              { staticClass: "h1 p-title p-black p-center mb-0 relawayBold" },
              [_vm._v("How it works")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "works-item  wave-1" }, [
              _c("div", { staticClass: "img p-center" }, [
                _c("img", { attrs: { src: "/img/phone.svg", alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "desc" }, [
                _c("p", { staticClass: "min p-center p-dgrey p-bold" }, [
                  _vm._v(
                    "\n                            Add your postcode and amount of power you spend per year\n                        "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "works-item  wave-2" }, [
              _c("div", { staticClass: "img p-center" }, [
                _c("img", { attrs: { src: "/img/scales2.svg", alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "desc" }, [
                _c("p", { staticClass: "min p-center  p-dgrey p-bold" }, [
                  _vm._v(
                    "\n                            Add your postcode and amount of power you spend per year\n                        "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "works-item" }, [
              _c("div", { staticClass: "img p-center" }, [
                _c("img", { attrs: { src: "/img/cash.svg", alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "desc" }, [
                _c("p", { staticClass: "min p-center  p-dgrey p-bold mb-0" }, [
                  _vm._v(
                    "\n                            Add your postcode and amount of power you spend per year\n                        "
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }